export const CollaboratorType = {
  PI: { value: "APPLICANT_PI", label: "PI" },
  Lead: { value: "LEAD_COLLAB", label: "Lead" },
  Collaborator: { value: "COLLAB", label: "Collaborator" },
};

export const CollaboratorTypes = [
  CollaboratorType.PI,
  CollaboratorType.Lead,
  CollaboratorType.Collaborator
];

export const CollaboratorTypesByValue = new Map<string, typeof CollaboratorType[keyof typeof CollaboratorType]>(
    Object.values(CollaboratorType).map((entry) => [entry.value, entry])
);

